
import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom';
import GetFetch from '../helper/GetFetch';

export const FacturaElectronica = () => {

    const [stadoForm, setStadoForm] = useState(0);

    useEffect(() => {
        let datos = localStorage.getItem('dataUser');
        const dataAlumno = JSON.parse(datos);
        const data = new FormData();
        data.append('carnet', dataAlumno.carnet);
        GetFetch.dteStadoFormulario(data).then(datos=>{

            if (datos.result.length > 0) {
                setStadoForm(datos.result[0].estado);
            }
        })
    }, [])




  return (
    <>
    {
        stadoForm === 0
            ?
            <div className='alert alert-info mb-4' role='alert'>
                <p className='mb-2'><b>Factura electrónica:</b> actualiza tus datos para la emisión de DTE.</p>
                <Link to='/dtealumnos' className='btn btn-info btn-sm'>
                    <i className="fa fa-pencil-square-o mr-1" aria-hidden="true"></i> Actualizar datos
                </Link>
            </div>
        : null
    }

    </>
  )
}

